<template>
  <div class="header-container">
    <!-- 导航 -->
    <div class="header_nav  w" :class="!isLogin?'unLogin':''">
      <div class="nav_logo" @click="$router.push('/')">
        <img :src="config.logo" :alt="config.site_title" style="width:104px;" class="pointer" />
      </div>
      <div class="nav_right">
        <div class="nav_group">
          <div class="nav-group-left">
            <router-link v-if="profile.is_new!==1"
                         class="nav_btn"
                         active-class="nav-active"
                         to="/#home">后台首页
            </router-link>
            <router-link v-if="profile.is_new!==1"
                         class="nav_btn"
                         active-class="nav-active"
                         to="/resource/news?is_zimeiti=2">
              门户媒体
              <svg-icon icon-class="hot" style="width: 30px;height: 16px;position:relative;top: -5px;"></svg-icon>

            </router-link>
            <router-link v-if="profile.is_new!==1"
                         class="nav_btn"
                         active-class="nav-active"
                         to="/resource/zimeiti?is_zimeiti=1">自媒体
            </router-link>
            <router-link v-if="profile.is_new!==1"
                         class="nav_btn"
                         :class="{'nav-active': isOverseas}"
                         active-class="nav-active"
                         to="/resource/overseas">海外媒体
            </router-link>
            <router-link v-if="profile.is_new!==1"
                         class="nav_btn"
                         active-class="nav-active"
                         to="/own/publish">文章发布
            </router-link>
            <!-- <router-link v-if="profile.is_new!==1"
                         class="nav_btn"
                         active-class="nav-active"
                         to="/own/copy_write">文章代写
            </router-link> -->

            <a v-if="profile.recharge===1"
               class="nav_btn"
               active-class="nav-active"
               :href="config.indexHost+ '/product/monitoring'"
               target="_blank"
            >舆情监测
            </a>
            <router-link v-if="profile.recharge===1"
                         class="nav_btn"
                         active-class="nav-active"
                         to="/recharge_center">在线充值
            </router-link>

            <!--<router-link class="nav_btn" style="margin-right: 0px;" active-class="nav-active"
                         to="/resource/brand">商标转让
            </router-link>-->
            <!--<img class="menu-item-tag"
                 src="https://xinmeibao.oss-cn-hangzhou.aliyuncs.com/uploads/190/210625/804ffd66d92558153eb6bda91a2b9039.png"
                 style="width: 16px;height: 16px;">-->
            <!--<router-link v-for="(e,index) in taxonomies" class="nav_btn" active-class="nav-active"
                         :to="'/resource/'+index" :key="index">{{ e }}
            </router-link>-->
            <!--<router-link class="nav_btn" style="width: 70px;margin-right: 0px;" active-class="nav-active"
                         to="/resource/400">400电话
            </router-link>
            <img class="menu-item-tag"
                 src="https://xinmeibao.oss-cn-hangzhou.aliyuncs.com/wxdyy/images/new.png"
                 style="width: 33px;height: 12px;">-->


            <!--<a class="nav_btn" active-class="nav-active"
               style="width: 90px;margin-right: 0px;"
               target="_blank"
               href="https://www.zfmarket.net/case.html?utm_source=xinmeibao_uc&utm_medium=&utm_campaign=&utm_content=&utm_term=来源于新媒宝&cegduid=">公众号涨粉
            </a>
            <img class="menu-item-tag"
                 src="https://xinmeibao.oss-cn-hangzhou.aliyuncs.com/wxdyy/images/new.png"
                 style="width: 33px;height: 12px;">-->
          </div>
          <!--<div class="nav-group-right">
            <router-link to="/#home" class="user-center nav_btn">
              <img src="../../assets/header-icon1.png" alt="">用户中心
            </router-link>
            &lt;!&ndash;<router-link to="/own" class="make_recharge nav_btn" style="margin:0 24px">
              <i class="iconfont"></i>订单中心
            </router-link>&ndash;&gt;
            <router-link v-if="profile.recharge===1" to="/recharge_center" class="make_recharge nav_btn">
              <img src="../../assets/header-icon2.png" alt="">充值中心
            </router-link>
          </div>-->
        </div>
      </div>
      <div class="head_top_right">
        <el-popover
            placement="bottom-end"
            width="274"
            trigger="hover">
          <div class="user" slot="reference">
            <img :src="profile.avatar" alt="" style="width: 30px;">
            &nbsp;ID: {{ profile.id }}
          </div>
          <div class="user-popover">
            <div class="user-info-box">
              <img :src="profile.avatar" alt="">
              <div>
                <div class="fz-16 fw-b">会员名：{{ profile.name }}</div>
                <div class="fz-14">用户ID:{{ profile.id }}</div>
                <div class="fz-14">手机号码:{{ profile.mobile }}</div>
              </div>
            </div>
            <div class="balance-box mt-10 fz-14 fw-b">
              <svg-icon icon-class="currency"
                        style="width: 22px;height: 22px;color: #0070ef;margin-left: 16px;margin-right: 9px;" />
              账户余额： <span style="color: #ff2222;">{{ profile.balance }}</span>&nbsp;元
            </div>
            <div class="user-popover-links">
              <a class="user-popover-link-item" href="/">
                <svg-icon
                    icon-class="https://ruanwenjie.oss-cn-hangzhou.aliyuncs.com/ucenter/header/user-popover01.svg"
                    style="width: 12px;height: 16px;margin-right: 8px;" />
                用户中心
                <div class="flex-spacer"></div>
                <i class="el-icon-arrow-right"></i>
              </a>
              <a class="user-popover-link-item" href="/own/copy_write">
                <svg-icon
                    icon-class="https://ruanwenjie.oss-cn-hangzhou.aliyuncs.com/ucenter/header/user-popover02.svg"
                    style="width: 11px;height: 14px;margin-right: 8px;" />
                文章撰写
                <div class="flex-spacer"></div>
                <i class="el-icon-arrow-right"></i>
              </a>
              <a class="user-popover-link-item" href="/recharge_center">
                <svg-icon
                    icon-class="https://ruanwenjie.oss-cn-hangzhou.aliyuncs.com/ucenter/header/user-popover03.svg"
                    style="width: 11px;height: 13px;margin-right: 8px;" />
                在线充值
                <div class="flex-spacer"></div>
                <i class="el-icon-arrow-right"></i>
              </a>
              <a class="user-popover-link-item" href="/own/personal/profile">
                <svg-icon
                    icon-class="https://ruanwenjie.oss-cn-hangzhou.aliyuncs.com/ucenter/header/user-popover04.svg"
                    style="width: 14px;height: 12px;margin-right: 8px;" />
                个人资料
                <div class="flex-spacer"></div>
                <i class="el-icon-arrow-right"></i>
              </a>
            </div>
            <div class="logout">
              <a @click="onLogout" class="pointer">退出登录</a>
            </div>
          </div>
        </el-popover>

        <!--<span>用户名：
            <router-link to="/"></router-link>
          </span>
        <span>用户ID：
            <router-link to="/">{{ profile.id }}</router-link>
          </span>
        <span v-if="profile.recharge===1">余额：
            <router-link to="/recharge_center" class="pointer active">￥{{ profile.balance }}</router-link>
          </span>
        &lt;!&ndash;<span>
          <router-link to="/cart?taxonomy=woa" class="pointer emphasize">购物车</router-link>
        </span>&ndash;&gt;
        &lt;!&ndash;<span>
          <router-link to="/own/order" class="pointer">订单中心</router-link>
        </span>&ndash;&gt;
        <span>
            <a @click="onLogout" class="pointer">退出</a>
          </span>-->
      </div>
    </div>

  </div>

</template>

<script>
import * as Cookies from 'js-cookie'

export default {
  data() {
    return {
      person: {},
      index: 0,
      show: true
    }
  },
  computed: {
    profile() {
      return this.$store.state.profile
    },
    isLogin() {
      return this.$store.state.auth.isLogin
    },
    taxonomies() {
      return this.$store.state.taxonomy
    },
    isOverseas() {
      const path = this.$route.path || ''
      return path.indexOf('/resource/overseas') === 0 || path.indexOf('/media/') === 0
    },
    urlCallback() {
      return escape(document.URL)
    }
  },
  created() {
    if (this.$route.path.split('/')[1] == 'resource') {
      this.show = true
    } else if (this.$route.path.split('/')[1] == 'cart') {
      this.show = true
    } else {
      this.show = false
    }
  },
  methods: {
    onLogout() {
      let loadingInstance = this.$loading({
        text: '注销中...'
      })

      this.$http
          .post('/auth/logout', {device: 'pc'})
          .then(response => {
            if (response.success) {
              //Cookies.remove("bearer");
              window.location.href = '/login'
            }
          })
          .catch()
          .then(() => {
            this.$nextTick(() => {
              loadingInstance.close()
            })
          })
    }
  }
}

</script>

<style scoped lang="scss">
@import './../../../config.scss';

/* 头部 */


.header-container {
  background: #fff;
}

.head {
  background-color: $--head-background;
  -webkit-box-shadow: 0px 4px 6px 0px rgba(182, 182, 182, 0.25);
  -moz-box-shadow: 0px 4px 6px 0px rgba(182, 182, 182, 0.25);
  box-shadow: 0px 4px 6px 0px rgba(182, 182, 182, 0.25);
}

.head.unLogin {
  background-color: $--color-primary;
  position: fixed;
  width: 100%;
  z-index: 100;

  .head_top {
    color: #fff;
    text-align: center;
    justify-content: center;

    .btn {
      border: 1px solid #fff;
      padding: 3px 10px;
      color: #fff;
      border-radius: 2px;

      &:first-child {
        margin-right: 12px;
      }
    }
  }
}

.head_top {
  width: 1480px;
  font-size: 12px !important;
  height: 38px;
  color: $--head-color;
  display: flex;
  justify-content: space-between;
  min-width: 1480px;
  margin-left: auto;
  margin-right: auto;
  align-items: center;
}

.head_top_left {
  padding-left: 20px;
}

.head_top_right {
  font-size: 16px;
  color: #666;

  .user {
    height: 100%;
    display: flex;
    align-items: center;
  }


}

.user-popover {
  padding: 8px;

  .user-info-box {
    display: flex;
    align-items: center;

    > img {
      width: 45px;
      margin-right: 14px;
    }
  }

  .balance-box {
    width: 230px;
    height: 46px;
    background: #F1F4F6;
    border-radius: 6px;
    display: flex;
    align-items: center;
  }

  .user-popover-links {
    margin-top: 12px;
    padding-bottom: 10px;
    background: url("https://ruanwenjie.oss-cn-hangzhou.aliyuncs.com/ucenter/header/shadow.png") no-repeat center bottom;

    .user-popover-link-item {
      height: 38px;
      padding: 0 16px;
      display: flex;
      align-items: center;
    }
  }

  .logout {
    height: 35px;
    padding-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.head_top_right > span {
  margin-right: 5px;
}

.head_top_right a {
  color: $--head-color;
}

.head_top_right > span:last-child {
  margin-right: 0;
}

.head_top ul {
  /* float: right; */
  margin-right: 48px;
}

.head_top ul li {
  float: left;
  /* margin-left: 10px; */
  font-size: 14px;
  line-height: 35px;
}

.head_top .tel {
  float: right;
  height: 35px;
  line-height: 40px;
}

.head_top_right a.active {
  color: #FF0000;
}

.head_top_right a.emphasize {
  color: #0082E6;
}

/* 导航 */

.header_nav {
  width: 1480px;
  height: 66px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header_nav.unLogin {
  padding-top: 38px;
}

.header_nav .nav_logo {
  width: 180px;
  display: flex;
  align-items: center;
}


.header_nav .nav_right {
  flex: 1;
}

.nav_group {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.nav-group-left {
  flex: 1;
  display: flex;
}


.nav-group-right {
  display: flex;
  justify-content: flex-end;
}

.nav_btn {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  height: 36px;
  padding: 8px 10px;
  border-radius: 18px;
  margin-right: 30px;

  > img {
    margin-right: 8px;
  }

}


.per_center_right ul {
  width: 496px;
  /* margin-right: 36px; */
}

.nav_btn.nav-active {
  background: $--color-primary;
  color: #fff;
  border-radius: 18px;
}

.per_center_right li {
  font-size: 14px;
  color: #434343;
  float: left;
  /* width: 20%; */
  text-align: center;
  line-height: 57px;
  padding: 21px 15px 0;
}

.per_center_right li > a {
  color: #333333;
}

.make_recharge, .user-center {
  width: 110px;
  background: #5185FF;
  color: #fff;
  font-size: 14px;

  i {
    margin-right: 4px
  }
}

.make_recharge {
  background: #ffa800;
}

.header-nav {
  display: flex;
  justify-content: space-between;
}

.header-nav > div {
  margin-left: 278px;
}

.header-nav > div > li {
  margin-right: 20px;
}

.steps {
  display: flex;
  height: 90px;
  justify-content: center;
  align-items: center;
}

.step-item {
  width: 200px;
}

.step-item:nth-child(4) {
  width: 17%;
}

.step-item > span {
  color: #999999;
  font-size: 16px;
}

.step-item > span:first-child {
  display: inline-block;
  width: 35px;
  height: 35px;
  background-color: #c9c9c9;
  border-radius: 50%;
  text-align: center;
  line-height: 35px;
  color: #ffffff;
}

.step-item > span:nth-child(3) {
  margin-left: 20px;
}

.steps > .active > span:nth-child(1) {
  background-color: $--color-primary;
}

.steps > .active > span:nth-child(2) {
  color: $--color-primary;
}

</style>



// WEBPACK FOOTER //
// src/components/global/Header.vue